"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateServiceTemplateFormToPayloadDataHandler = updateServiceTemplateFormToPayloadDataHandler;
const findDifferences = (existing, newServices) => {
    if (!newServices.services || !existing.services) {
        return [];
    }
    return newServices.services.filter(newService => {
        var _a;
        const existingService = (_a = existing.services) === null || _a === void 0 ? void 0 : _a.find(service => (service === null || service === void 0 ? void 0 : service.service) === (newService === null || newService === void 0 ? void 0 : newService.service));
        return !existingService || existingService.status !== (newService === null || newService === void 0 ? void 0 : newService.status);
    });
};
function updateServiceTemplateFormToPayloadDataHandler(data, template) {
    const initialData = template.initialData || { services: [], notes: "" };
    const differences = findDifferences(initialData, data);
    const servicesArray = differences.length > 0 ? differences : initialData.services || [];
    const services = servicesArray.reduce((acc, service) => {
        if (service === null || service === void 0 ? void 0 : service.service)
            acc[service.service] = service === null || service === void 0 ? void 0 : service.status;
        return acc;
    }, {}) || {};
    return {
        form: {
            services,
            notes: data.notes,
        },
    };
}
